import { ViewModel, View, ObservableArray } from "binder"
import { NetworkedStationManipulationView } from "./networkedStationManipulation-view"
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { NetworkedStationEditorViewModel, NetworkedStationInserter, NetworkedStationUpdater } from "./networkedStationEditor/networkedStationEditor-viewModel";
import { INetworkedStation } from "./INetworkedStation";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";

export class NetworkedStationManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف ایستگاه جمع آوری اطلاعات';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.networkedStations = ObservableArray.create<NetworkedStation>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new NetworkedStationManipulationView();
    }
    public getTypeId(): string {
        return "VM-D895F921-98A1-413D-A894-0BB0BA4EE873"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set networkedStations(v: ObservableArray<NetworkedStation>) { this._networkedStations = v; } public get networkedStations(): ObservableArray<NetworkedStation> { return this._networkedStations; } private _networkedStations: ObservableArray<NetworkedStation>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/DataCollectionStationServices/ListAllNetworkedStations', {
                FilteringInformation: filteringInformation
            });
            this.networkedStations.update(...result.NetworkedStations.map((x, i) => {
                let n = new NetworkedStation(this);
                n.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                n.id = x.Id;
                n.macAddress = x.MacAddress;
                return n;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new NetworkedStationEditorViewModel(this, new NetworkedStationInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(networkedStation: INetworkedStation) {
        let popup = new NetworkedStationEditorViewModel(this, new NetworkedStationUpdater());
        await networkedStation.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(networkedStation: NetworkedStation): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/DataCollectionStationServices/DeleteNetworkedStation", {
                    NetworkedStationId: networkedStation.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class NetworkedStation extends ViewModel implements INetworkedStation {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: NetworkedStationManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: NetworkedStationManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set macAddress(v: string) { this._macAddress = v; } public get macAddress(): string { return this._macAddress; } private _macAddress: string;

    async cloneTo(networkedStation: INetworkedStation) {
        networkedStation.id = this.id;
        networkedStation.macAddress = this.macAddress;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
